import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatToolbarModule } from '@angular/material/toolbar';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

import { AuthInterceptor } from './authinterceptor.class';
import { AutofocusDirective } from './autofocus/autofocus.AutofocusDirective';
import { LoggingOutComponent } from './logging-out/logging-out.component';
import { LoginComponent } from './login-component/login.component';
import { LoginResolverService } from './services/login-clear.services';
import { LoginService } from './services/login-service.service';
import { MatCheckboxModule } from '@angular/material/checkbox';

export const appRoutes: Routes = [
    {
        path: 'Login',
        component: LoginComponent,
        resolve: { login: LoginResolverService },
    },
    { path: 'Logout', component: LoggingOutComponent },
];

@NgModule({
    declarations: [LoginComponent, LoggingOutComponent, AutofocusDirective],
    imports: [
        BrowserModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MatInputModule,
        MatButtonModule,
        MatRadioModule,
        MatDialogModule,
        MatToolbarModule,
        MatCardModule,
        MatIconModule,
        MatCheckboxModule,
        RouterModule.forChild(appRoutes),
    ],
    exports: [LoginComponent],
    providers: [CookieService],
})
export class LoginModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: LoginModule,
            providers: [
                LoginResolverService,
                LoginService,
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: AuthInterceptor,
                    multi: true,
                },
            ],
        };
    }
}
